import {MessagePreview} from "omoplay";

const MessageWrapPreview = ({ messageData, type, fixed, isShowToggle, onCouponClick }) => {

  return (
      <MessagePreview messageData={messageData ?? {}} type={type ?? messageData?.type} fixed={fixed}
                      isShowToggle={isShowToggle} onCouponClick={onCouponClick}
      />
  );
};

export default MessageWrapPreview;
